import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { MHColours, GENERAL_FONT } from '../../constants/theme';

const ErrorFallback = () => (
  <Box
    sx={{
      minHeight: '100vh',
      backgroundColor: MHColours.mhBackground,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: GENERAL_FONT,
      px: 3,
      textAlign: 'center',
    }}
  >
    <Typography
      variant="h5"
      fontWeight={700}
      sx={{ color: MHColours.mhGreenDark, mb: 1, fontFamily: GENERAL_FONT }}
    >
      Något gick fel
    </Typography>
    <Typography
      variant="body1"
      sx={{
        color: MHColours.mhGrayDark,
        mb: 4,
        maxWidth: 400,
        fontFamily: GENERAL_FONT,
      }}
    >
      Ett oväntat fel har uppstått. Prova att ladda om sidan — om problemet
      kvarstår, kontakta support.
    </Typography>
    <Button
      variant="contained"
      onClick={() => window.location.reload()}
      sx={{
        backgroundColor: MHColours.mhGreen,
        color: '#fff',
        textTransform: 'none',
        fontFamily: GENERAL_FONT,
        borderRadius: '999px',
        px: 4,
        '&:hover': { backgroundColor: MHColours.mhGreenDark },
      }}
    >
      Ladda om sidan
    </Button>
  </Box>
);

export default ErrorFallback;
